<template>
  <ToggleSwitch
    v-model="value"
    :options="options"
    :label="label"
  />
</template>

<script setup lang="ts">
import { useField } from "vee-validate"
import type { ToggleSwitchOption } from "./ToggleSwitch.vue"

const props = defineProps<{
  name: string
  label?: string
  options: Array<ToggleSwitchOption>
}>()

const { value } = useField<boolean>(toRef(props, "name"))
</script>
